import FloorsView from './FloorsView';

export default FloorsView;
